import type { GeoJsonObject } from "geojson";
import type { OrganizationMap } from "../../auth/data";
import type { OrganizationMapConfig } from "../commons/Constant";

const isFiniteNumber = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value);

const isCoordinate = (value: unknown): value is [number, number] =>
  Array.isArray(value) &&
  value.length === 2 &&
  isFiniteNumber(value[0]) &&
  isFiniteNumber(value[1]);

export function toOrganizationMapConfig(
  organizationMap: OrganizationMap | null | undefined,
  boundary?: GeoJsonObject,
): OrganizationMapConfig | null {
  if (!organizationMap || organizationMap.organization_type !== "city") {
    return null;
  }

  const { center, max_bounds: maxBounds, zoom } = organizationMap.map_config ?? {};
  if (
    !isCoordinate(center) ||
    !Array.isArray(maxBounds) ||
    maxBounds.length !== 2 ||
    !isCoordinate(maxBounds[0]) ||
    !isCoordinate(maxBounds[1]) ||
    !isFiniteNumber(zoom) ||
    !Number.isInteger(zoom) ||
    zoom < 1 ||
    zoom > 22
  ) {
    return null;
  }

  return {
    boundary,
    center,
    maxBounds: [maxBounds[0], maxBounds[1]],
    zoom,
  };
}
